export const filterImageInstance = (imgInstance, width) => imgInstance.width === width;
export const imageRankComparator = (imgA, imgB) =>
	imgA.rank > imgB.rank ? 1 : imgA.rank < imgB.rank ? -1 : 0;

export const isImage = filepath => {
	if (!filepath) {
		throw new TypeError('No filepath given');
	}

	if (typeof filepath !== 'string') {
		throw new TypeError('Path to image must be a string');
	}

	return Boolean(/\.(png|jpe?g|gif|webp|svg)(\?.*)?$/.test(filepath));
};
